import { FirebaseApp, initializeApp, getApps } from 'firebase/app';
import { Messaging, getMessaging, isSupported, getToken } from 'firebase/messaging';
import { registerServiceWorker } from '@utilities/serviceWorker/serviceWorkerUtils';

const firebaseConfig = {
	apiKey: window.config.FCM_API_KEY,
	authDomain: window.config.FCM_AUTH_DOMAIN,
	projectId: window.config.FCM_PROJECT_ID,
	storageBucket: window.config.FCM_STORAGE_BUCKET,
	messagingSenderId: window.config.FCM_MESSAGING_SENDER_ID,
	appId: window.config.FCM_APP_ID,
};
const VAPID_KEY = window.config.FCM_VAPID_KEY;

export const getFirebaseApp = (): FirebaseApp => {
	const existingApps = getApps();
	return existingApps.length > 0 ? existingApps[0] : initializeApp(firebaseConfig);
};

export const getFirebaseMessaging = async (): Promise<Messaging> => {
	const app = getFirebaseApp();
	if (!(await isSupported())) {
		throw new Error('Firebase Messaging is not supported in this browser.');
	}
	return getMessaging(app);
};

export const getFirebaseToken = async (): Promise<string | null> => {
	if (Notification.permission !== 'granted') {
		return null;
	}

	try {
		const registration = await registerServiceWorker();
		if (!registration) {
			return null;
		}

		const messaging = await getFirebaseMessaging();
		const token = await getToken(messaging, {
			vapidKey: VAPID_KEY,
			serviceWorkerRegistration: registration,
		});
		return token;
	} catch (error) {
		console.error('Error retrieving Firebase token:', error);
		return null;
	}
};
